import { constructQueryParams } from '@/utils/utils';
import api from '../services/axios.service';

export async function fetchLogs(
    {
        timestamp_from, from, size, source_ids, destination_ids, log_level, query_string
    } = {
        timestamp_from: undefined,
        from: 0,
        size: 10,
        source_ids: undefined,
        destination_ids: undefined,
        log_level: undefined,
        query_string: null
    }
) {
    const queryParams = constructQueryParams({ timestamp_from, from, size, log_level, query_string });

    const body = source_ids || destination_ids ? { source_ids: source_ids ?? [], destination_ids: destination_ids ?? [] } : {};

    return api.post(`logs?${queryParams}`, body);
}
